import * as React from "react";
const SvgDevice = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.6667 9.50008V3.83341C15.6667 2.89999 15.6667 2.43328 15.485 2.07676C15.3252 1.76316 15.0703 1.50819 14.7567 1.3484C14.4001 1.16675 13.9334 1.16675 13 1.16675H5C4.06658 1.16675 3.59987 1.16675 3.24335 1.3484C2.92975 1.50819 2.67478 1.76316 2.51499 2.07676C2.33333 2.43328 2.33333 2.89999 2.33333 3.83341V9.50008M16.5 9.50008V10.1667C16.5 11.1002 16.5 11.5669 16.3183 11.9234C16.1586 12.237 15.9036 12.492 15.59 12.6518C15.2335 12.8334 14.7668 12.8334 13.8333 12.8334H4.16667C3.23325 12.8334 2.76654 12.8334 2.41002 12.6518C2.09641 12.492 1.84144 12.237 1.68166 11.9234C1.5 11.5669 1.5 11.1002 1.5 10.1667V9.50008H5.94772C6.15154 9.50008 6.25345 9.50008 6.34936 9.52311C6.43439 9.54352 6.51568 9.57719 6.59024 9.62288C6.67433 9.67442 6.7464 9.74648 6.89052 9.89061L6.94281 9.94289C7.08694 10.087 7.159 10.1591 7.2431 10.2106C7.31766 10.2563 7.39894 10.29 7.48397 10.3104C7.57988 10.3334 7.68179 10.3334 7.88562 10.3334H10.1144C10.3182 10.3334 10.4201 10.3334 10.516 10.3104C10.6011 10.29 10.6823 10.2563 10.7569 10.2106C10.841 10.1591 10.9131 10.087 11.0572 9.94289L11.1095 9.89061C11.2536 9.74648 11.3257 9.67442 11.4098 9.62288C11.4843 9.57719 11.5656 9.54352 11.6506 9.52311C11.7465 9.50008 11.8485 9.50008 12.0523 9.50008H16.5Z",
      stroke: "#01653A",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgDevice;
